import Sir_img from "../Assets/Vipin Sir.jfif";

const mentorinfo = [
  {
    id: 1,
    mentor_name: "PROF. VIPIN VIBHUTE",
    imgURL: Sir_img,
    content:
      "Corporate Relations Officer at Dr. DY Patil Educational Complex and Assistant Professor at DY Patil College of Engineering (Instrumentation & Control). 5 years of experience in industry and 25+ years in teaching.",
    linkedURL: "https://www.linkedin.com/in/vipin-vibhute-97708220/",
    instagramURl: "https://www.instagram.com/vipinvibhute/",
    twitterURL: "https://twitter.com/vipinv23?t=_Nivhr8VEvqjt-PASGmB8g&s=08ASGmB8g&s=08",
  },
];
export default mentorinfo;
